import { useCartContext } from "context/cart-context";
import { OutsideClickHandler } from "..";
import "./index.scss";

export const MenuCartBody = ({ children }) => {
  const { cartIsOpen, toggleCartOpening } = useCartContext();
  if (!cartIsOpen) return null;

  return (
    <div className="menu-cart-body-overlay">
      <OutsideClickHandler onOutsideClick={() => toggleCartOpening()}>
        <div
          className="menu-cart-body-dropdown"
          data-testid="menu-cart-body-dropdown"
        >
          {children}
        </div>
      </OutsideClickHandler>
    </div>
  );
};
